module.exports = __webpack_public_path__ + "static/media/edit_card_description.5341eaab.gif";